import {QbElement} from "@qb-assets-js/qb-elements/qb-element"
import {GET, POST, PUT, PATCH, DELETE, FETCH} from "@qb-assets-js/qb-fetch"
export {GET, POST, PUT, DELETE, PATCH, FETCH};
export {QbElement}

export class Qb3Element extends QbElement {
    get path() {
       return this.ancestors().map(n=>n.uri).filter(u=>u).reverse().join("/").replace(/\/+/g, "/");
    }

    set persisted(value) {
        this.setClass(value, 'persisted')
    }

    get itemposition() {
        const rv = []
        for(let node = this;;node = node.parentElement) {
            if(!node || node.hasClass("qb-quiz")) break;
            let fn = node.__lookupGetter__("round");
            if(!fn) fn = node.__lookupGetter__("index");
            if(fn) rv.push(fn.call(node));
        }
        return rv.filter(n=>n || n ===0).join("-");
    }

    get index() { return parseInt(this.dataset.index) }
    set index(value) { this.dataset.index = parseInt(value) || 0 }

    // classNodeName(type, fallback) {
    //     return `qb-${(type || fallback).replace(/^::/, '').replace(/::/g,'-')}`.toUpperCase();
    // }

    get save() {
        const closest = this.ancestors().find(n=>n.__lookupGetter__('params'));
        if(!closest) return;
        const path = this.path,
            method = /\/new(\/|$)/.test(path) ? 'POST' : 'PATCH';
        return FETCH(path, {method, params: this.params})
    }

    get enclosing() {
        let node = this.closest(".qb-show");
        if(node) return node;
        return this.closest("qb-quiz") || this.closest(".qb-task");
    }

    set type(value) {
        this.itemtype = value;
    }
    get type() {
        return this.itemtype.replace(/^.*\//, '');
    }

    set content(value) {
        QB_GETTEXT({className: 'content', beforeend: this, findBy: ".content"}).content = value;
    }

}
